// See: ../application/environment.d.ts

window.Ok = <T, _K>(value: T) => {
	return {
		err: null,
		ok: value,
	};
};

window.Err = <_T, K>(value: K) => {
	return {
		err: value,
		ok: null,
	};
};
